var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsIn, IsInt, IsOptional, IsString, ValidateNested } from 'class-validator';
import { LanguageLevelValues } from '../commons';
export class ManfrediteOfferFilterCreateRequest {
    static _OPENAPI_METADATA_FACTORY() {
        return { lang: { required: true, type: () => Object, enum: ['EN', 'ES'] }, currency: { required: false, type: () => String }, offerLanguage: { required: false, type: () => Object, enum: ['EN', 'ES'] }, minSalary: { required: false, type: () => Number }, text: { required: false, type: () => String }, remoteOptions: { required: true, type: () => [Object], enum: ['remote', 'hybrid', 'face-to-face'] }, locations: { required: true, type: () => [String] }, techs: { required: true, type: () => [Number] }, techRoles: { required: true, type: () => [Number] }, minLanguages: { required: true, type: () => [require("./manfredite-offer-filter-create.request").ManfrediteOfferFilterCreateRequestMinLanguage] } };
    }
}
__decorate([
    Expose(),
    IsString(),
    IsIn(['EN', 'ES']),
    __metadata("design:type", String)
], ManfrediteOfferFilterCreateRequest.prototype, "lang", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], ManfrediteOfferFilterCreateRequest.prototype, "currency", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsIn(['EN', 'ES']),
    __metadata("design:type", String)
], ManfrediteOfferFilterCreateRequest.prototype, "offerLanguage", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], ManfrediteOfferFilterCreateRequest.prototype, "minSalary", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], ManfrediteOfferFilterCreateRequest.prototype, "text", void 0);
__decorate([
    Expose(),
    IsIn(['remote', 'hybrid', 'face-to-face'], { each: true }),
    __metadata("design:type", Array)
], ManfrediteOfferFilterCreateRequest.prototype, "remoteOptions", void 0);
__decorate([
    Expose(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], ManfrediteOfferFilterCreateRequest.prototype, "locations", void 0);
__decorate([
    Expose(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ManfrediteOfferFilterCreateRequest.prototype, "techs", void 0);
__decorate([
    Expose(),
    IsInt({ each: true }),
    __metadata("design:type", Array)
], ManfrediteOfferFilterCreateRequest.prototype, "techRoles", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => ManfrediteOfferFilterCreateRequestMinLanguage),
    __metadata("design:type", Array)
], ManfrediteOfferFilterCreateRequest.prototype, "minLanguages", void 0);
export class ManfrediteOfferFilterCreateRequestMinLanguage {
    static _OPENAPI_METADATA_FACTORY() {
        return { languageId: { required: true, type: () => Number }, level: { required: true, type: () => Object, enum: LanguageLevelValues } };
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], ManfrediteOfferFilterCreateRequestMinLanguage.prototype, "languageId", void 0);
__decorate([
    Expose(),
    IsIn(LanguageLevelValues),
    __metadata("design:type", String)
], ManfrediteOfferFilterCreateRequestMinLanguage.prototype, "level", void 0);
//# sourceMappingURL=manfredite-offer-filter-create.request.js.map